import React, { useCallback, useEffect, useRef, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { CHECKOUT_URL, PRODUCT_NAME, previewImages } from '../data/atlante';
export function PreviewCarousel() {
  const trackRef = useRef<HTMLUListElement>(null);
  const [index, setIndex] = useState(0);
  const scrollTo = useCallback((i: number) => {
    const track = trackRef.current;
    if (!track) return;
    const clamped = Math.max(0, Math.min(previewImages.length - 1, i));
    const slide = track.children[clamped] as HTMLElement | undefined;
    if (slide) {
      track.scrollTo({
        left: slide.offsetLeft - track.offsetLeft,
        behavior: 'smooth'
      });
    }
  }, []);
  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;
    const onScroll = () => {
      const width = track.clientWidth;
      if (width === 0) return;
      setIndex(Math.round(track.scrollLeft / width));
    };
    track.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => track.removeEventListener('scroll', onScroll);
  }, []);
  return <section className="bg-navy px-4 py-5 sm:py-7" data-id="element-123" data-mp="3alvs4ux0cojp">
      <div className="mx-auto max-w-3xl" data-id="element-124" data-mp="3amf2nqkbwanp">
        <p className="text-center font-display text-[10px] font-extrabold uppercase tracking-[0.2em] text-gold sm:text-xs" data-id="element-125" data-mp="3fli6x8shicum">
          Anteprima del materiale
        </p>
        <h2 className="mt-1 text-center text-xl leading-tight text-white sm:text-2xl" data-id="element-126" data-mp="3ke1i5z3p8vw9">
          Scopri l’interno di {PRODUCT_NAME}
        </h2>
        <p className="mx-auto mt-1.5 max-w-2xl text-center text-[13px] font-medium leading-snug text-white/85" data-id="element-127" data-mp="3tbu07b0t2hnc">
          Esplora anatomia visuale, preparazioni, restauri, implantoprotesi,
          protesi rimovibile, occlusione, comparazioni, casi clinici e strumenti
          professionali pronti da consultare inclusi nel sistema completo.
        </p>

        <div className="relative mt-3" data-id="element-128" data-mp="2401mx1fstufc">
          <ul ref={trackRef} className="no-scrollbar flex snap-x snap-mandatory gap-3 overflow-x-auto scroll-smooth" aria-label="Anteprima delle pagine interne del sistema" data-id="element-129" data-mp="28w086g5tywbj">
            {previewImages.map(image => <li key={image.src} className="w-full shrink-0 snap-center" data-id="element-130" data-mp="2aua0k09eek7x">
                <a href={CHECKOUT_URL} className="block" data-id="element-131" data-mp="2as6yghuz10mu">
                  <img src={image.src} alt={image.alt} loading="lazy" className="mx-auto w-full rounded-lg border-2 border-gold/60 bg-white shadow-2xl" data-id="element-132" data-mp="25u5gy1d719dh" />
                </a>
              </li>)}
          </ul>

          <button type="button" onClick={() => scrollTo(index - 1)} disabled={index === 0} aria-label="Pagina precedente" className="absolute left-1 top-1/2 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-white/95 text-navy shadow-lg transition-colors duration-150 hover:bg-gold hover:text-white disabled:pointer-events-none disabled:opacity-0" data-id="element-133" data-mp="2tk85w8lt9z7v">
            <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-134" data-mp="3m796n1ewueq8" />
          </button>
          <button type="button" onClick={() => scrollTo(index + 1)} disabled={index === previewImages.length - 1} aria-label="Pagina successiva" className="absolute right-1 top-1/2 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-white/95 text-navy shadow-lg transition-colors duration-150 hover:bg-gold hover:text-white disabled:pointer-events-none disabled:opacity-0" data-id="element-135" data-mp="3m4vfh3ncpmny">
            <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-136" data-mp="2pijsnm6em69j" />
          </button>
        </div>

        <div className="mt-2.5 flex items-center justify-center gap-2" data-id="element-137" data-mp="2titwotamymlr">
          {previewImages.map((image, i) => <button key={image.src} type="button" onClick={() => scrollTo(i)} aria-label={`Vai alla pagina ${i + 1} di ${previewImages.length}`} aria-current={i === index} className={`h-2 rounded-full transition-[width,background-color] duration-200 ease-soft ${i === index ? 'w-6 bg-gold' : 'w-2 bg-white/40 hover:bg-white/70'}`} data-id="element-138" data-mp="2fl5btlgkjfgp" data-mpi={i} />)}
        </div>
      </div>
    </section>;
}